<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewAddressForm = !showNewAddressForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewAddressForm, 'fa-minus-circle': showNewAddressForm }"></i>&nbsp;New Address</h6>
  <div class="card-body" [hidden]="!showNewAddressForm" style="max-height: 340px; overflow-y: scroll">
    <app-address-form [contactId]="contactId" (saved)="formSaved($event)"></app-address-form>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="loadingAddresses" (click)="loadAddresses()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingAddresses }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody [appNativeSortableJs]="addresses" [sortableOptions]="sortableOptions">
    <tr *ngFor="let address of addresses; let i = index">
      <td *ngIf="!address.editing">
        <div class="alias-sort-handle d-inline-block py-1 px-2" style="cursor: grab" title="Sort">
          <i class="fas fa-random"></i>
        </div>
        <div class="btn-group btn-group-sm">
          <button title="Edit" (click)="address.editing = true" type="button" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button title="Delete" (click)="deleteAddress(address, i)" type="button" class="btn btn-outline-danger btn-sm">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </td>
      <td *ngIf="!address.editing" title="Full Address" class="border-right">
        <span [innerHTML]="address.address_display"></span>
        <br />
        <div class="text-center">
          <app-clipboard-btn *ngIf="address.address_clipboard" [errorNotificationMessage]="'Error copying address'" [content]="address.address_clipboard" [successNotificationMessage]="'Address copied'" [title]="'Copy Address'"></app-clipboard-btn>
        </div>
      </td>
      <td *ngIf="!address.editing" title="Address Type(s)">
        <span [innerHTML]="address.type_names"></span>
      </td>
      <td *ngIf="address.editing" colspan="3">
        <div class="card">
          <div class="card-body" style="max-height: 340px; overflow-y: scroll">
            <h6 class="text-info font-italic card-title">Editing Address</h6>
            <app-address-form [address]="address" (saved)="formSaved($event, address)"></app-address-form>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
